/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_TimerInputs */



/**
* | output |
* | --- |
* | "### Timer Set a **Round time** on the tournament and a shared countdown appears once a round starts, synced to every device watching. It is as useful in a ha..." |
*
* @param {Og_TimerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_timer = /** @type {((inputs?: Og_TimerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_TimerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("### Chronomètre\n\nDéfinissez une **Durée de ronde** sur le tournoi et un compte à rebours partagé apparaît au démarrage d'une ronde, synchronisé sur tous les appareils. C'est aussi utile dans une salle qu'en ligne.")
	if (locale === "es") return /** @type {LocalizedString} */ ("### Temporizador\n\nDefine un **Tiempo de ronda** en el torneo y aparece una cuenta atrás compartida al empezar una ronda, sincronizada en todos los dispositivos. Es igual de útil en una sala que en línea.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("### Cronômetro\n\nDefina um **Tempo de rodada** no torneio e uma contagem regressiva compartilhada aparece quando uma rodada começa, sincronizada em todos os dispositivos. É tão útil num salão quanto on-line.")
	if (locale === "it") return /** @type {LocalizedString} */ ("### Timer\n\nImposta un **Tempo del round** sul torneo e all'avvio di un round compare un conto alla rovescia condiviso, sincronizzato su ogni dispositivo. È utile in una sala quanto online.")
	return /** @type {LocalizedString} */ ("### Timer\n\nSet a **Round time** on the tournament and a shared countdown appears once a round starts, synced to every device watching. It is as useful in a hall as online.")
});